// document.addEventListener("DOMContentLoaded", (event) => {
$(document).ready(function() {
    $('.cwc-card-content h4').click(function() {
        $(this).closest('.cwc-card-content').toggleClass('active');
        $(this).closest('.cwc-card-content').find('.cwc-card-content-body').slideToggle();
    })
  
    const lenis = new Lenis({
      autoRaf: true
    });
    gsap.registerPlugin(ScrollTrigger);
    gsap.from(".hero-banner-content-inner>*", {
        y: "100%",
        opacity:0,
        duration:1
    });
  
    if(window.innerWidth < 768){
        $(".top-features-inner .normal-cards-inner").slick({
           slidesToShow:1,
           slidesToScroll:1,
           arrows:false
        });
        $(".top-features-inner .cwc-inner").slick({
           slidesToShow:1,
           infinite:false,
           slidesToScroll:1,
           arrows:false
        });
        $(".software-features-inner .normal-cards-inner").slick({
           slidesToShow:1,
           infinite:false,
           slidesToScroll:1,
           arrows:false,
           dots:true
        });

        gsap.from(".top-features-main .normal-cards", {
            scrollTrigger:{
                trigger: ".top-features-main",
                start: "-20% 50%",
                end: "80% 100%",
                scrub: true,
                // markers: true,
            },
            y: "25%",
            opacity:0
        });
        gsap.from(".top-features-main .card-with-content", {
            scrollTrigger:{
                trigger: ".top-features-main",
                start: "15% 50%",
                end: "80% 100%",
                scrub: true,
                // markers: true,
            },
            x: "100%",
        });

         gsap.from(".multiple-role-body .cwc-inner .cwc-inner-cards .cwc-card:first-child", {
            scrollTrigger:{
                trigger: ".multiple-role-body",
                start: "25% 70%",
                end: "60% 100%",
                scrub: true,
                // markers: true,
            },
            x: "-40%",
            opacity:0
        });
        gsap.from(".multiple-role-body .cwc-inner .cwc-inner-cards .cwc-card:last-child", {
            scrollTrigger:{
                trigger: ".multiple-role-body",
                start: "35% 70%",
                end: "80% 100%",
                scrub: true,
                // markers: true,
            },
            x: "40%",
            opacity:0
        });
        gsap.from(".multiple-role-body .cwc-inner>.cwc-card", {
            scrollTrigger:{
                trigger: ".multiple-role-body",
                start: "0% 70%",
                end: "50% 100%",
                scrub: true,
                // markers: true,
            },
            x: "40%",
            opacity:0
        });
    }else{
        gsap.to(".top-features-main .normal-card:first-child, .top-features-main .normal-card:last-child", {
            scrollTrigger:{
                trigger: ".top-features-main",
                start: "-20% 50%",
                end: "80% 100%",
                scrub: true,
                // markers: true,
            },
            y: "90%",
        });
        gsap.to(".top-features-main .cwc-card:first-child, .top-features-main .cwc-card:last-child", {
            scrollTrigger:{
                trigger: ".top-features-main",
                start: "25% 50%",
                end: "150% 100%",
                scrub: true,
                // markers: true,
            },
            y: "-40%",
        });
        
        gsap.from("section.banner-consumption .image-banner-content", {
            scrollTrigger:{
                trigger: "section.banner-consumption",
                start: "10% 70%",
                end: "80% 100%",
                scrub: true,
                // markers: true,
            },
            x: "-100%",
        });
        gsap.to("section.banner-consumption img", {
            scrollTrigger:{
                trigger: "section.banner-consumption",
                start: "10% 70%",
                end: "40% 50%",
                // markers: true,
            },
            opacity: 1,
        });
        gsap.from(".multiple-role-body .cwc-inner .cwc-inner-cards .cwc-card:first-child", {
            scrollTrigger:{
                trigger: ".multiple-role-body",
                start: "-25% 70%",
                end: "50% 100%",
                scrub: true,
                // markers: true,
            },
            x: "-40%",
            opacity:0
        });
        gsap.from(".multiple-role-body .cwc-inner .cwc-inner-cards .cwc-card:last-child", {
            scrollTrigger:{
                trigger: ".multiple-role-body",
                start: "25% 70%",
                end: "110% 100%",
                scrub: true,
                // markers: true,
            },
            x: "-40%",
            opacity:0
        });
        gsap.from(".multiple-role-body .cwc-inner>.cwc-card", {
            scrollTrigger:{
                trigger: ".multiple-role-body",
                start: "0% 70%",
                end: "110% 100%",
                scrub: true,
                // markers: true,
            },
            x: "40%",
            opacity:0
        });
        gsap.from("section.banner-records h2", {
            scrollTrigger:{
                trigger: "section.banner-records",
                start: "0% 70%",
                end: "70% 100%",
                scrub: true,
                // markers: true,
            },
            y: "40%",
            opacity:0
        });
    }

    gsap.from(".software-features-main .heading-one", {
            scrollTrigger:{
                trigger: ".software-features-main",
                start: "-15% 50%",
                end: "10% 50%",
                scrub: true,
                // markers: true,
            },
            x: "-100%",
        });
        gsap.from(".software-features-main .heading-two", {
            scrollTrigger:{
                trigger: ".software-features-main",
                start: "10% 70%",
                end: "20% 60%",
                scrub: true,
                // markers: true,
            },
            x: "100%",
        });
        gsap.from(".software-features-image-inner img", {
            scrollTrigger:{
                trigger: ".software-features-main",
                start: "10% 70%",
                end: "30% 60%",
                scrub: true,
                // markers: true,
            },
            scale: 0,
        });
        gsap.from(".software-features-main .normal-card", {
            scrollTrigger:{
                trigger: ".software-features-main",
                start: "25% 70%",
                end: "110% 100%",
                scrub: true,
                // markers: true,
            },
            scale: 0,
        });
})
// })